import { Helmet } from 'react-helmet-async'
import { useTranslation } from 'shared/i18n'
import ViewPrivacyPolicy from './view'

export default function PrivacyPolicyPage (): JSX.Element {
  const { t } = useTranslation()
  return (
    <>
      <Helmet>
        <title>{t('privacyPolicy.privacyPolicy.text')}</title>
      </Helmet>

      <ViewPrivacyPolicy />
    </>
  )
}
